module.exports = __webpack_public_path__ + "static/media/background1.8969d7c9.png";